import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonFilterRequest, CommonResult } from '../../../models/quotation-model/customer.model';
import { Insurance } from '../../../models/quotation-model/catalogs/insurance.model';
import {
  QuoterInsurancePaged,
  QuoterInsurance,
  QuoterInsuranceZonePaged,
  QuoterInsuranceZone,
  QuoterInsuranceZoneStatePaged,
  QuoterInsuranceZoneState,
  QuoterInsuranceCoveragePaged,
  QuoterInsuranceCoverage,
  QuoterInsuranceCoverageGuardPaged,
  QuoterInsuranceCoverageGuard,
  QuoterInsuranceCoverageFactorPaged,
  QuoterInsuranceCoverageFactor,
  QuoterInsuranceCoverageVehicleUsePaged,
  QuoterInsuranceCoverageVehicleUse,
  QuoterInsuranceDeadlinePaged,
  QuoterInsuranceDeadline,
  QuoterInsuranceRangePaged,
  QuoterInsuranceRange,
  QuoterInsuranceCategoryPaged,
  QuoterInsuranceCategory,
  QuoterInsurancePersonPaged,
  QuoterInsurancePerson,
  QuoterInsuranceDealerPaged,
  QuoterInsuranceDealer,
  QuoterInsuranceUdiPaged,
  QuoterInsuranceUdi,
  QuoterInsuranceMailPaged,
  QuoterInsuranceMailDocument,
  QuoterInsuranceMailDocumentSelect,
  QuoterInsuranceMailStage,
  QuoterInsuranceMailStageSelect,
} from '../../../models/quotation-model/catalogs/quoterConfig/quoter-insurance.model';
import { environment } from '../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InsuranceService {
  URL_API = environment.apiURL;
  constructor(private http: HttpClient) {}

  getInsurance(): Observable<Insurance[]> {
    return this.http.get<Insurance[]>(this.URL_API + '/Insurance');
  }

  getPagedInsurances(filters: CommonFilterRequest): Observable<QuoterInsurancePaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ?? '');
    return this.http.get<QuoterInsurancePaged>(this.URL_API + '/Insurance/GetPagedInsurances', {
      params,
    });
  }

  upsertQuoterInsurance(upsertInsurance: QuoterInsurance) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Insurance/UpsertInsurance',
      upsertInsurance,
    );
  }

  getPagedInsuranceZones(
    filters: CommonFilterRequest,
    InsuranceId: number,
  ): Observable<QuoterInsuranceZonePaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ?? '')
      .set('InsuranceId', InsuranceId);
    return this.http.get<QuoterInsuranceZonePaged>(
      this.URL_API + '/Insurance/GetPagedInsuranceZones',
      {
        params,
      },
    );
  }

  upsertQuoterInsuranceZone(upsertInsuranceZone: QuoterInsuranceZone) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Insurance/UpsertInsuranceZone',
      upsertInsuranceZone,
    );
  }

  getPagedInsuranceZoneStates(
    filters: CommonFilterRequest,
    InsuranceId: number,
    ZoneId: number,
  ): Observable<QuoterInsuranceZoneStatePaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ?? '')
      .set('InsuranceId', InsuranceId)
      .set('ZoneId', ZoneId);
    return this.http.get<QuoterInsuranceZoneStatePaged>(
      this.URL_API + '/Insurance/GetPagedInsuranceZoneStates',
      {
        params,
      },
    );
  }

  upsertQuoterInsuranceZoneState(upsertInsuranceZoneState: QuoterInsuranceZoneState) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Insurance/UpsertZoneState',
      upsertInsuranceZoneState,
    );
  }

  getPagedInsuranceCoverages(
    filters: CommonFilterRequest,
    InsuranceId: number,
  ): Observable<QuoterInsuranceCoveragePaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ?? '')
      .set('InsuranceId', InsuranceId);
    return this.http.get<QuoterInsuranceCoveragePaged>(
      this.URL_API + '/Insurance/GetPagedInsuranceCoverages',
      {
        params,
      },
    );
  }

  upsertQuoterInsuranceCoverage(upsertInsuranceCoverage: QuoterInsuranceCoverage) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Insurance/UpsertInsuranceCoverage',
      upsertInsuranceCoverage,
    );
  }

  getPagedInsuranceCoverageGuards(
    filters: CommonFilterRequest,
    CoverageId: number,
  ): Observable<QuoterInsuranceCoverageGuardPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ?? '')
      .set('CoverageId', CoverageId);
    return this.http.get<QuoterInsuranceCoverageGuardPaged>(
      this.URL_API + '/Insurance/GetPagedInsuranceCoverageGuards',
      { params },
    );
  }

  upsertQuoterInsuranceCoverageGuard(upsertInsuranceCoverageGuard: QuoterInsuranceCoverageGuard) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Insurance/UpsertInsuranceCoverageGuard',
      upsertInsuranceCoverageGuard,
    );
  }

  getPagedInsuranceCoverageFactors(
    filters: CommonFilterRequest,
    CoverageId: number,
  ): Observable<QuoterInsuranceCoverageFactorPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ?? '')
      .set('CoverageId', CoverageId);
    return this.http.get<QuoterInsuranceCoverageFactorPaged>(
      this.URL_API + '/Insurance/GetPagedInsuranceCoverageFactors',
      { params },
    );
  }

  upsertQuoterInsuranceCoverageFactor(
    upsertInsuranceCoverageFactor: QuoterInsuranceCoverageFactor,
  ) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Insurance/UpsertInsuranceCoverageFactor',
      upsertInsuranceCoverageFactor,
    );
  }

  getPagedInsuranceCoverageVehicleUses(
    filters: CommonFilterRequest,
    CoverageId: number,
    UseId: number,
  ): Observable<QuoterInsuranceCoverageVehicleUsePaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ?? '')
      .set('CoverageId', CoverageId)
      .set('UseId', UseId);
    return this.http.get<QuoterInsuranceCoverageVehicleUsePaged>(
      this.URL_API + '/Insurance/GetPagedCoverageVehicleUses',
      { params },
    );
  }

  upsertQuoterInsuranceCoverageVehicleUse(
    upsertInsuranceCoverageVehicleUse: QuoterInsuranceCoverageVehicleUse,
  ) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Insurance/UpsertCoverageVehicleUse',
      upsertInsuranceCoverageVehicleUse,
    );
  }

  getPagedInsuranceDeadlines(
    filters: CommonFilterRequest,
    InsuranceId: number,
  ): Observable<QuoterInsuranceDeadlinePaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ?? '')
      .set('InsuranceId', InsuranceId);
    return this.http.get<QuoterInsuranceDeadlinePaged>(
      this.URL_API + '/Insurance/GetPagedInsuranceDeadlines',
      {
        params,
      },
    );
  }

  upsertQuoterInsuranceDeadline(upsertInsuranceDeadline: QuoterInsuranceDeadline) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Insurance/UpsertInsuranceDeadline',
      upsertInsuranceDeadline,
    );
  }

  getPagedInsuranceRanges(
    filters: CommonFilterRequest,
    InsuranceId: number,
  ): Observable<QuoterInsuranceRangePaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ?? '')
      .set('InsuranceId', InsuranceId);
    return this.http.get<QuoterInsuranceRangePaged>(
      this.URL_API + '/Insurance/GetPagedInsuranceRanges',
      {
        params,
      },
    );
  }

  upsertQuoterInsuranceRange(upsertInsuranceRange: QuoterInsuranceRange) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Insurance/UpsertInsuranceRange',
      upsertInsuranceRange,
    );
  }

  getPagedInsuranceCategories(
    filters: CommonFilterRequest,
    InsuranceId: number,
  ): Observable<QuoterInsuranceCategoryPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ?? '')
      .set('InsuranceId', InsuranceId);
    return this.http.get<QuoterInsuranceCategoryPaged>(
      this.URL_API + '/Insurance/GetPagedInsuranceCategories',
      {
        params,
      },
    );
  }

  upsertQuoterInsuranceCategory(upsertInsuranceCategory: QuoterInsuranceCategory) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Insurance/UpsertInsuranceCategory',
      upsertInsuranceCategory,
    );
  }

  getPagedInsurancePersons(
    filters: CommonFilterRequest,
    InsuranceId: number,
  ): Observable<QuoterInsurancePersonPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ?? '')
      .set('InsuranceId', InsuranceId);
    return this.http.get<QuoterInsurancePersonPaged>(
      this.URL_API + '/Insurance/GetPagedInsurancePersonTypes',
      {
        params,
      },
    );
  }

  upsertQuoterInsurancePerson(upsertInsurancePerson: QuoterInsurancePerson) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Insurance/UpsertInsurancePerson',
      upsertInsurancePerson,
    );
  }

  getPagedInsuranceDealers(
    filters: CommonFilterRequest,
    InsuranceId: number,
  ): Observable<QuoterInsuranceDealerPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ?? '')
      .set('InsuranceId', InsuranceId);
    return this.http.get<QuoterInsuranceDealerPaged>(
      this.URL_API + '/Insurance/GetPagedInsuranceDealers',
      {
        params,
      },
    );
  }

  upsertQuoterInsuranceDealer(upsertInsuranceDealer: QuoterInsuranceDealer) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Insurance/UpsertInsuranceDealer',
      upsertInsuranceDealer,
    );
  }

  getPagedInsuranceUdis(
    filters: CommonFilterRequest,
    InsuranceId: number,
  ): Observable<QuoterInsuranceUdiPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ?? '')
      .set('InsuranceId', InsuranceId);
    return this.http.get<QuoterInsuranceUdiPaged>(
      this.URL_API + '/Insurance/GetPagedInsuranceUdis',
      {
        params,
      },
    );
  }

  upsertQuoterInsuranceUdi(upsertInsuranceUdi: QuoterInsuranceUdi) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Insurance/UpsertInsuranceUdi',
      upsertInsuranceUdi,
    );
  }

  getPagedInsuranceMails(
    filters: CommonFilterRequest,
    InsuranceId: number,
  ): Observable<QuoterInsuranceMailPaged> {
    const params = new HttpParams()
      .set('page', filters.page.toString())
      .set('pageSize', filters.pageSize.toString())
      .set('sortActive', filters.sortActive)
      .set('sortDirection', filters.sortDirection)
      .set('filter', filters.filter ?? '')
      .set('InsuranceId', InsuranceId);
    return this.http.get<QuoterInsuranceMailPaged>(
      this.URL_API + '/Insurance/GetPagedInsuranceMails',
      {
        params,
      },
    );
  }

  getInsuranceMailDocuments(
    mailId: number,
    insuranceId: number,
  ): Observable<QuoterInsuranceMailDocument[]> {
    return this.http.get<QuoterInsuranceMailDocument[]>(
      this.URL_API +
        '/Insurance/GetQuoterInsuranceMailDocuments?mailId=' +
        mailId +
        '&insuranceId=' +
        insuranceId,
    );
  }

  upsertQuoterInsuranceMailDocument(
    upsertInsuranceMailDocument: QuoterInsuranceMailDocumentSelect,
    insuranceId: number,
  ) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Insurance/UpsertInsuranceMailDocument?insuranceId=' + insuranceId,
      upsertInsuranceMailDocument,
    );
  }

  getInsuranceMailStages(
    mailId: number,
    insuranceId: number,
  ): Observable<QuoterInsuranceMailStage[]> {
    return this.http.get<QuoterInsuranceMailStage[]>(
      this.URL_API +
        '/Insurance/GetQuoterInsuranceMailStages?mailId=' +
        mailId +
        '&insuranceId=' +
        insuranceId,
    );
  }

  upsertQuoterInsuranceMailStage(
    upsertInsuranceMailStage: QuoterInsuranceMailStageSelect,
    status: string,
  ) {
    return this.http.post<CommonResult>(
      this.URL_API + '/Insurance/UpsertInsuranceStage?status=' + status,
      upsertInsuranceMailStage,
    );
  }
}
